import { render, staticRenderFns } from "./configuracao-solicitacao-cirurgia.vue?vue&type=template&id=75a6ec6f&scoped=true"
import script from "./configuracao-solicitacao-cirurgia.ts?vue&type=script&lang=ts&external"
export * from "./configuracao-solicitacao-cirurgia.ts?vue&type=script&lang=ts&external"
import style0 from "./configuracao-solicitacao-cirurgia.scss?vue&type=style&index=0&id=75a6ec6f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a6ec6f",
  null
  
)

export default component.exports